module.exports = __webpack_public_path__ + "static/media/check.984aaf46.svg";